import React, { useEffect, useRef } from "react";

const WompiWidgetButton = ({ order, customerData, shippingAddress, className }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!order || !containerRef.current) {
      return undefined;
    }

    const container = containerRef.current;
    container.innerHTML = "";

    const script = document.createElement("script");
    script.src = "https://checkout.wompi.co/widget.js";
    script.async = true;
    script.setAttribute("data-render", "button");
    script.setAttribute("data-public-key", order.publicKey);
    script.setAttribute("data-currency", order.currency);
    script.setAttribute("data-amount-in-cents", String(order.amountInCents));
    script.setAttribute("data-reference", order.reference);
    if (order.signature) {
      script.setAttribute("data-signature:integrity", order.signature);
    }
    if (order.redirectUrl) {
      script.setAttribute("data-redirect-url", order.redirectUrl);
    }

    if (customerData?.email) {
      script.setAttribute("data-customer-data:email", customerData.email);
    }
    if (customerData?.fullName) {
      script.setAttribute("data-customer-data:full-name", customerData.fullName);
    }
    if (customerData?.phoneNumber) {
      script.setAttribute("data-customer-data:phone-number", customerData.phoneNumber);
    }
    if (customerData?.phoneNumberPrefix) {
      script.setAttribute(
        "data-customer-data:phone-number-prefix",
        customerData.phoneNumberPrefix,
      );
    }
    if (customerData?.legalId) {
      script.setAttribute("data-customer-data:legal-id", customerData.legalId);
    }
    if (customerData?.legalIdType) {
      script.setAttribute("data-customer-data:legal-id-type", customerData.legalIdType);
    }

    if (shippingAddress?.addressLine1) {
      script.setAttribute(
        "data-shipping-address:address-line-1",
        shippingAddress.addressLine1,
      );
    }
    if (shippingAddress?.addressLine2) {
      script.setAttribute(
        "data-shipping-address:address-line-2",
        shippingAddress.addressLine2,
      );
    }
    if (shippingAddress?.country) {
      script.setAttribute("data-shipping-address:country", shippingAddress.country);
    }
    if (shippingAddress?.city) {
      script.setAttribute("data-shipping-address:city", shippingAddress.city);
    }
    if (shippingAddress?.region) {
      script.setAttribute("data-shipping-address:region", shippingAddress.region);
    }
    if (shippingAddress?.phoneNumber) {
      script.setAttribute(
        "data-shipping-address:phone-number",
        shippingAddress.phoneNumber,
      );
    }
    if (shippingAddress?.postalCode) {
      script.setAttribute(
        "data-shipping-address:postal-code",
        shippingAddress.postalCode,
      );
    }
    if (shippingAddress?.name) {
      script.setAttribute("data-shipping-address:name", shippingAddress.name);
    }

    script.setAttribute("data-collect-shipping", "true");

    container.appendChild(script);

    return () => {
      container.innerHTML = "";
    };
  }, [order, customerData, shippingAddress]);

  return <div ref={containerRef} className={className} />;
};

export default WompiWidgetButton;
